import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const useDayPickerStyles = createUseStyles({
  dayPicker: {
    position: 'relative',
    display: 'flex',
    margin: '0 0.5em',
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #ddd',
    borderRadius: 4,
    background: '#fff',
    cursor: 'pointer'
  },
  daySlider: {
    position: 'absolute',
    display: 'flex',
    width: 0,
    height: '100%',
    overflow: 'hidden',
    left: 0,
    top: 0,
    backgroundColor: '#fff',
    transition: 'all 0.2s ease-in-out',
    borderRadius: 4,
    zIndex: 999,
    '& > span': {
      display: 'flex',
      flex: 1,
      fontSize: 12,
      color: '#333',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        backgroundColor: '#f3f4f6'
      }
    }
  },
  daySliderActive: {
    width: 230,
    border: `1px solid ${colors.primary1}`
  },
  dayActive: {
    backgroundColor: `${colors.primary1} !important`,
    color: '#fff !important'
  },
  dayValue: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    padding: '0 10px'
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none'
  }
})

export { useDayPickerStyles }
